import { createSelector } from 'reselect';
import { FEATURES } from '@/constants';
import { appState } from './utils';
const _featuresConfig = createSelector(appState, ({ featuresConfig = {} }) => featuresConfig);
export const getAllFeatures = createSelector(_featuresConfig, ({ features = {} }) => {
    // exp client returns only enabled features so we map missing features to false
    Object.values(FEATURES).forEach(featureKey => {
        if (!features[featureKey]) {
            features[featureKey] = false;
        }
    });
    return features;
});
export const getFeatureByKey = (featureKey) => createSelector(_featuresConfig, ({ features = {} }) => !!features[featureKey]);
export const getFeatureConfig = (featureKey) => createSelector(_featuresConfig, ({ config = {} }) => config[featureKey]);
